export enum ExternalLinks {
  privacyPolicyLink = 'https://www.acuvue.com/ru-ru/privacy-policy/',
  myAcuvueProgramPolicyLink = 'https://www.acuvue.com/ru-ru/pravila-programmy-myacuvue/',
  legalNoticeLink = 'https://www.acuvue.com/ru-ru/terms-of-use/',
  consentLink = 'https://www.acuvue.com/ru-ru/сonsent-to-receive-promo-info',
  mobileMarket = 'https://myacuvue.onelink.me/o8U8/acuvueru',
  ruStore = 'https://myacuvue.onelink.me/o8U8/acuvueru',
  locator = 'https://myacuvue.onelink.me/o8U8/ECPLocator',
  // Wiki links
  visionAndGadgets = 'https://www.acuvue.com/ru-ru/eye-health/digital-eye-strain/',
  visionAndWork = 'https://www.acuvue.com/ru-ru/eye-health/tips-for-work/',
  visionAndUV = 'https://www.acuvue.com/ru-ru/considering-contacts/uv-blocking-benefits/',
  popularProblems = 'https://www.acuvue.com/ru-ru/eye-health/common-vision-issues/',
  astigmatismWiki = 'https://www.acuvue.com/ru-ru/eye-health/astigmatism/',
  presbyopiaWiki = 'https://www.acuvue.com/ru-ru/eye-health/presbyopia/',
  weeklyLenses = 'https://www.acuvue.com/ru-ru/products/?page=1&replacement_schedule%5B0%5D=biweekly',
  dailyLenses = 'https://www.acuvue.com/ru-ru/products/?page=1&replacement_schedule%5B0%5D=daily',
  typesOfLenses = 'https://www.acuvue.com/ru-ru/products/types-of-contacts/',
  cleanAndCare = 'https://www.acuvue.com/ru-ru/new-wearer/contact-lens-cleaning-and-care/',
  takeOutLenses = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/',
  usefulTips = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/',
  putInLenses = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/',
  commonMyths = 'https://www.acuvue.com/ru-ru/considering-contacts/contact-lens-myths/',
  lensesBenefits = 'https://www.acuvue.com/ru-ru/considering-contacts/new-contact-lenses/',
  contactLensesFacts = 'https://www.acuvue.com/ru-ru/considering-contacts/why-acuvue/',
  fittingPreparation = 'https://www.acuvue.com/ru-ru/get-contacts/prepare-for-appointment/',
  lensesFitting = 'https://www.acuvue.com/ru-ru/get-contacts/how-to-get-contacts/',
  // Social media
  mailLink = 'mailto:acuvue@jnj.ru',
  phoneNumber = '88006007997',
  mobileLinkRevitalLens = 'https://myacuvue.onelink.me/o8U8/dsvm7p8c',
  myopia = 'https://www.acuvue.ru/ru-ru/eye-health/myopia?utm_source=MA&utm_medium=email&utm_campaign=crm-miopiya',
  presbyopia = 'https://www.acuvue.com/ru-ru/eye-health/presbyopia?utm_source=MA&utm_medium=email&utm_campaign=crm-presbiopia',
  astigmatism = 'https://www.acuvue.com/ru-ru/eye-health/astigmatism?utm_source=MA&utm_medium=email&utm_campaign=crm-astigmatism',
  phoneConsentLink = 'https://www.acuvue.ru/ru-ru/consent-to-phone-calls/',
}
